import * as Type from './types';

export const loadTips = (tips: string[]) => (dispatch: any) => dispatch({ type: Type.TIPS_LOADED, payload: tips });
export const clearTips = () => (dispatch: any) => dispatch({ type: Type.TIPS_CLEARED });
